module.exports = __webpack_public_path__ + "img/af5ee36.png";